import * as React from 'react';
import { useEffect, useState } from "react";
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import Select from 'antd/lib/select';
import Modal from 'antd/lib/modal';
import Button from 'antd/lib/button';
import Input from 'antd/lib/input';
import notification from 'antd/lib/notification';
import Typography from "antd/lib/typography";
import Spin from "antd/lib/spin";
import DatePicker from "antd/lib/date-picker";
const { Text } = Typography;
import Layout from "antd/lib/layout";
const { Content } = Layout;
import moment from 'moment';
import {
    AddNewProps
} from './addnewprops';
import {
    useDispatch,
} from 'react-redux';

import {
    AddNewType
} from 'one-model-local';

import {
    setAction as addNewFormAction,
    resetNotification,
    setSpin,
} from 'one-state-addnew';
import { useCtx } from "one-ui-provider";

const {
    Option,
} = Select;

export const AddNewFormEnable = (
    props: AddNewProps
) => {
    const {
        value,
        choosecaller,
    } = props;
    const ani = choosecaller?.number;
    const dispatch = useDispatch();
    const [subtype] = useState([]);
    const [name, setName] = useState(undefined);
    const [phone, setPhone] = useState(undefined);
    const [type, setType] = useState(undefined);
    const [subtypeval, setSubTypeVal] = useState(undefined);
    const [address, setAddress] = useState(undefined);
    const [email, setEmail] = useState(undefined);
    const [dob, setDob] = useState(undefined);
    const [department, setDepartment] = useState(undefined);

    const { settings } = useCtx();
    const { uisettings } = settings;
    const { source_card: { departments }} = uisettings;

    const handleClear = (e: any) => {
        setName("");
        setPhone(ani);
        setType("");
        setSubTypeVal("");
        setAddress("");
        setEmail("");
        setDob("");
        setDepartment("");
    }

    useEffect(() => {
        //to set ani in phone hook as hook is already initialized by undefied
        if (choosecaller?.number != undefined && phone === undefined) {
            setPhone(ani);
        }
        // to reset the phone hook when on call end as the hook is not getting 
        // re-initalized to undefined at on call end
        if (choosecaller?.number === undefined && phone != undefined) {
            setPhone(undefined);
        }
    }, [choosecaller]);
    //To reset the hooks
    if (value?.notificationmsg === 'Record Inserted Successfully.') {
        let note: AddNewType = {};
        note.notification = false;
        note.notificationmsg = "";
        dispatch(resetNotification(
            note
        ));
        //this time out is set for not to re-render the component multiple times
        //and throw and error.
        setTimeout(handleClear, 2000);
    } else if (value?.notificationmsg === "Caller record was not successfully created.") {
        let notenotsuccess: AddNewType = {};
        notenotsuccess.notification = false;
        notenotsuccess.notificationmsg = "";
        dispatch(resetNotification(
            notenotsuccess
        ));
    }

    const onFinish = (values: any) => {
        let validate = false;
        let finaladdress = address;
        if (name === "" || name === undefined) {
            validate = true;
            notification['error']({
                message: 'Enter Valid Name',
                description: "",
            });
        } else if (!name.match(/^[a-zA-Z0-9 ]*$/)) {
            validate = true;
            notification['error']({
                message: 'Enter Valid Name',
                description: "",
            });
        } else if (phone === "" || phone === undefined) {
            validate = true;
            notification['error']({
                message: 'Enter Phone Number',
                description: "",
            });
        } else if (!phone.match(/^[0-9-]*$/)) {
            validate = true;
            notification['error']({
                message: 'Enter Valid Phone Number',
                description: "",
            });
        } else if (phone && phone?.length < 10) {
            validate = true;
            notification['error']({
                message: 'Enter Valid 10 digit Phone Number',
                description: "",
            });
        } else if (type === "" || type === undefined) {
            validate = true;
            notification['error']({
                message: 'Select Type',
                description: "",
            });
        } else if (!type.match(/^[a-zA-Z]*$/)) {
            validate = true;
            notification['error']({
                message: 'Select Valid Type',
                description: "",
            });
        } else if (subtypeval === "" || subtypeval === undefined) {
            validate = true;
            notification['error']({
                message: 'Select Sub Type',
                description: "",
            });
        } else if (!subtypeval.match(/^[a-zA-Z ]*$/)) {
            validate = true;
            notification['error']({
                message: 'Select Valid Sub Type',
                description: "",
            });
        } else if (address && !address.match(/^[a-zA-Z0-9 -\/,.]*$/)) {
            validate = true;
            notification['error']({
                message: 'Enter Valid Address',
                description: "",
            });
        }
        // else if (email === "" || email === undefined) {
        //     validate = true;
        //     notification['error']({
        //         message: 'Enter Email',
        //         description: "",
        //     });
        //}
        else if (email && !email.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)) {        
            validate = true;
            notification['error']({
                message: 'Enter Valid Email',
                description: "",
            });
        }
        if (!validate) {
            let addspin: AddNewType = {};
            addspin.addnewspin = true;
            dispatch(setSpin(
                addspin
            ));
            dispatch(
                {
                    type: "one-state-addnew/call",
                    payload: {
                        name: name,
                        phone: phone,
                        address: finaladdress,
                        department,
                        typeName: type,
                        subTypeName: subtypeval,
                        email: email,
                        dateofbirth: dob
                    }
                }
            );
        }
    };

    const handleCancel = (e: any) => {
        handleClear("");
        dispatch(
            addNewFormAction(
                {
                    value: false
                }
            )
        )
    };


    const onDepartmentChange = (value: string) => {
        setDepartment(value);
    }

    const onNameChange = (e: any) => {
        if (e.which === 32 && !e.target.value.length)
        {
            e.preventDefault();
        }
        else 
        {
            setName(e.target.value);
        }
    }
    const onPhoneChange = (e: any) => {
        setPhone(e.target.value);
    }
    const onSubTypeChange = (e: any) => {
        setSubTypeVal(e);
    }
    const onAddressChange = (e: any) => {
        setAddress(e.target.value);
    }
    const onEmailChange = (e: any) => {
        setEmail(e.target.value);
    }
    const onDobChange = (e: any) => {
        setDob(e);
    }

    const dateFormat = 'YYYY-MM-DD';

    function disabledDate(current: any) {
        // Can not select days before today and today
        return current && current > moment().subtract(1, "days");
      }

    const generalform = (
        <form>
            <Layout className='addnewlayout'>
                <Content>
                    <Row type="flex" gutter={[24, 24]}>
                        <Col span={12} md={6}>
                            <Text>Name: </Text>
                            <Input value={name} autoComplete="new-password" allowClear={true} onChange={(e) => onNameChange(e)} maxLength={50} />
                        </Col>
                        <Col span={12} md={6}>
                            <Text>Phone Number: </Text>
                            <Input value={phone} autoComplete="new-password" onChange={(e) => onPhoneChange(e)} maxLength={12} />
                        </Col>

                        {/* <Col span={12} md={6}>
                            <Text>Type: </Text>
                            <Select onChange={(e: any) => onTypeChange(e)} value={type}>
                                <Option value="Patient">Patient</Option>
                                <Option value="Provider">Provider</Option>
                            </Select>
                        </Col> */}
                        <Col span={12} md={6}>
                            <Text>SubType: </Text>
                            <Select onChange={(e: any) => onSubTypeChange(e)} value={subtypeval}>
                                {subtype}
                            </Select>
                        </Col>
                    </Row>
                    <div className="ant-modal-hr" />
                    <Row type="flex" gutter={[24, 24]}>
                        <Col span={24} md={12}>
                            <Text>Date Of Birth:</Text>
                            <div>
                                <DatePicker placeholder="YYYY-MM-DD" value={dob} onChange={(e) => onDobChange(e)} disabledDate={disabledDate} format={dateFormat}/>
                            </div>
                        </Col>
                        <Col span={24} md={12}>
                            <Text>Email: </Text>
                            <Input value={email} autoComplete="new-password" onChange={(e) => onEmailChange(e)} maxLength={30} />
                        </Col>
                    </Row>
                    <Row type="flex" gutter={[24, 24]}>
                        <Col span={48} md={24}>
                            <Text>Address: </Text>
                            <Input autoComplete="new-password" onChange={(e) => onAddressChange(e)} value={address} maxLength={60} />
                        </Col>
                    </Row>
                    <Row type="flex" gutter={[24, 24]}>
                        <Col span={48} md={24}>
                            <Text>Department: </Text>
                            <Select onChange={(e: any) => onDepartmentChange(e)} value={department}>
                                {
                                    departments.map((item: string) => (
                                        <Option value={item}>{item}</Option>
                                    ))
                                }
                            </Select>
                        </Col>
                    </Row>
                    <div className="ant-modal-actions">
                        <Button key="back" onClick={handleClear}>
                            Clear
                     </Button>
                        <Button key="submit" type="primary" onClick={e => onFinish(e)}>
                            Add
                    </Button>
                    </div>
                </Content>
            </Layout>
        </form>
    );

    let formval = (
        <>
            <div className="new-call">
                <Modal
                    title="Add New Source"
                    width={650}
                    visible={value?.value}
                    footer={null}
                    centered
                    closable={true}
                    onCancel={handleCancel}
                    wrapClassName="custom-modal-wrap"
                    destroyOnClose
                >
                    <Spin spinning={value?.addnewspin} tip="Loading...">
                        {generalform}
                    </Spin>
                </Modal>
            </div>
        </>
    );
    return (
        <>
            {formval}
        </>
    );
}